import { render, staticRenderFns } from "./assetlocationhistory.vue?vue&type=template&id=06904f5e&scoped=true"
import script from "./assetlocationhistory.vue?vue&type=script&lang=js"
export * from "./assetlocationhistory.vue?vue&type=script&lang=js"
import style0 from "./assetlocationhistory.vue?vue&type=style&index=0&id=06904f5e&prod&scoped=true&lang=css"
import style1 from "./assetlocationhistory.vue?vue&type=style&index=1&id=06904f5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06904f5e",
  null
  
)

export default component.exports